import { Stack } from '@mui/material';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { BasePageTitle } from '~/components/BasePageTitle/BasePageTitle';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DataGridWidget } from '~/components/DataGridWidget';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RouteId } from '~/routes';

import { usePurchaseRequisitionDataGridConfig } from './PurchaseRequisitionList.dataGrid';
import { BASE_PURCHASE_REQUISITION_LIST_QUERY } from './PurchaseRequisitionList.gql';
import { usePurchaseRequisitionDataGridQueryBuilderConfig } from './PurchaseRequisitionList.queryBuilder';

const domain = BaseDomainType.PURCHASE_REQUISITION;

export const BasePurchaseRequisitionList = () => {
  const { queryId, query, onQueryChange, onQueryIdChange, rulesTotal, loading } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <PageHeaderStatic
            title={<BasePageTitle domain={domain} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
            right={
              <Stack
                spacing={3}
                direction="row"
                sx={{
                  overflow: 'hidden',
                  alignItems: 'center',
                }}
              >
                <Filters
                  {...filtersProps}
                  selected={selected}
                  onFilterSelect={(filter) => {
                    onQueryIdChange(filter.queryId);
                  }}
                />
              </Stack>
            }
          />
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={usePurchaseRequisitionDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <DataGridWidget
        domain={domain}
        loading={loading}
        filter={query}
        filterCount={rulesTotal}
        useConfig={usePurchaseRequisitionDataGridConfig}
        initialNavigateDetail={({ row }) => ({ to: RouteId.purchaseRequisitionDetail(row.id) })}
        loadingProps={{
          query: BASE_PURCHASE_REQUISITION_LIST_QUERY,
          getNodes: (data) => data.purchaseRequisitions.nodes,
          getTotalCount: (data) => data.purchaseRequisitions.totalCount || 0,
        }}
      />
    </PageLayout>
  );
};
